<h2 mat-dialog-title>
  {{ 'REFUND_DIALOG.TITLE' | translate }}
</h2>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div>
      <span class="description">
        <p class="secondary-text">{{ 'REFUND_DIALOG.TO' | translate }}:&nbsp;</p>
        <p *ngIf="(isLoading$$ | async) === false; else loadingShimmer">{{ companyName$ | async }}</p>
      </span>
      @if (data.payment.paymentMethodDetailsType === cardPaymentMethodType) {
        <p>{{ 'REFUND_DIALOG.DESCRIPTION' | translate }}</p>
        <ng-container *ngTemplateOutlet="invoiceCreditNote"></ng-container>
      } @else if (data.payment.paymentMethodDetailsType === achDebitPaymentMethodType) {
        <ng-container *ngTemplateOutlet="invoiceCreditNote"></ng-container>
        <glxy-alert type="warning">
          <strong>
            {{ 'REFUND_DIALOG.WARNING_ACH_TITLE' | translate }}
          </strong>
          <glxy-alert-extended class="secondary-text"
            ><span [innerHtml]="'REFUND_DIALOG.DESCRIPTION_ACH' | translate"></span
          ></glxy-alert-extended>
        </glxy-alert>
      } @else if (data.payment.paymentMethodDetailsType === acssDebitPaymentMethodType) {
        <ng-container *ngTemplateOutlet="invoiceCreditNote"></ng-container>
        <glxy-alert type="warning">
          <strong>
            {{ 'REFUND_DIALOG.WARNING_ACSS_TITLE' | translate }}
          </strong>
          <glxy-alert-extended class="secondary-text"
            ><span [innerHtml]="'REFUND_DIALOG.DESCRIPTION_ACSS' | translate"></span
          ></glxy-alert-extended>
        </glxy-alert>
      }
      <ng-template #invoiceCreditNote>
        @if (invoice()) {
          <p>
            {{ 'REFUND_DIALOG.ISSUE_CREDIT_NOTE' | translate }}
            <a mat-dialog-close (click)="issueCreditNote()" data-testid="credit-note-refund">{{
              'REFUND_DIALOG.ISSUE_CREDIT_NOTE_CTA' | translate: { invoiceNumber: invoice().formattedNumber }
            }}</a>
          </p>
        }
      </ng-template>
    </div>

    <glxy-alert *ngIf="(showNegativeBalanceAlert$ | async) === true" class="insufficient-funds-alert" type="warning">
      <strong>{{ 'REFUND_DIALOG.NEGATIVE_BALANCE_TITLE' | translate }}</strong>
      &mdash; {{ 'REFUND_DIALOG.NEGATIVE_BALANCE_DESCRIPTION' | translate }}
    </glxy-alert>

    <div class="col col-xs-12 col-sm-8">
      <glxy-form-field [prefixText]="currencySymbol" [size]="'small'">
        <glxy-label>{{ 'REFUND_DIALOG.AMOUNT' | translate }}</glxy-label>
        <input type="number" placeholder="{{ 'REFUND_DIALOG.AMOUNT' | translate }}" matInput formControlName="amount" />
        <glxy-error *ngIf="amountControl.hasError('required') || amountControl.hasError('isLessThanOrEqualToZero')">
          {{ 'REFUND_DIALOG.REFUND_MUST_BE_GREATER_THAN_ZERO' | translate }}:&nbsp;{{
            0 | currency: currencyCode : 'symbol' : '1.2-2'
          }}
        </glxy-error>
        <glxy-error *ngIf="amountControl.hasError('max')">
          {{ 'REFUND_DIALOG.REFUND_CANNOT_EXCEED_AMOUNT' | translate }}:&nbsp;{{
            paymentDollarAmount | currency: currencyCode : 'symbol' : '1.2-2'
          }}
        </glxy-error>
        <glxy-hint class="description">
          {{ 'REFUND_DIALOG.BALANCE' | translate }}:&nbsp;
          <ng-container *ngIf="(isLoading$$ | async) === false; else loadingShimmer">
            {{ balance$ | async | currency: currencyCode : 'symbol' : '1.2-2' }}
          </ng-container>
        </glxy-hint>
      </glxy-form-field>
    </div>
    <div class="col col-xs-12 col-sm-8">
      <glxy-form-field>
        <glxy-label>{{ 'REFUND_DIALOG.REASON' | translate }}</glxy-label>
        <mat-select placeholder="{{ 'REFUND_DIALOG.SELECT_REASON' | translate }}" formControlName="reason">
          <mat-option *ngFor="let option of reasonOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close type="button">
      {{ 'REFUND_DIALOG.CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="formGroup.invalid || (isSubmitting$$ | async) === true"
    >
      <glxy-button-loading-indicator [isLoading]="isSubmitting$$ | async">
        {{ 'REFUND_DIALOG.BUTTON' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </mat-dialog-actions>
</form>

<ng-template #loadingShimmer>
  <div class="col col-xs-6 col-sm-4 stencil-shimmer"></div>
</ng-template>
